export default function HowItWorksSection() {
  const steps = [
    {
      num: '01',
      icon: 'ri-global-line',
      title: 'Browse Categories',
      description: 'Start by exploring 14+ organized categories covering shoes, hoodies, jackets, bags, and more. Everything is arranged for quick navigation.',
    },
    {
      num: '02',
      icon: 'ri-search-line',
      title: 'Find Products',
      description: 'Scan through curated product listings with verified details. Each item is organized with clear information to help you decide.',
    },
    {
      num: '03',
      icon: 'ri-scales-3-line',
      title: 'Compare Options',
      description: 'Compare products across categories using the structured spreadsheet format. Make informed decisions with side-by-side data.',
    },
    {
      num: '04',
      icon: 'ri-external-link-line',
      title: 'Visit Main Website',
      description: 'Once you have found what you need, head over to the main website to explore the full product catalog and complete your shopping.',
    },
  ];

  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-4 tracking-wide">
            GETTING STARTED
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            How <span className="text-primary-500">Kakobuy Spreadsheet</span> Works
          </h2>
          <p className="mt-4 text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Four simple steps from browsing to discovering your next favorite product.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div key={step.num} className="relative group">
              <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 h-full">
                <div className="flex items-center gap-4 mb-4">
                  <span className="text-4xl font-heading font-bold text-primary-200 group-hover:text-primary-400 transition-colors duration-300">
                    {step.num}
                  </span>
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                    <i className={`${step.icon} text-xl`}></i>
                  </div>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">{step.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{step.description}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                  <div className="w-6 h-6 flex items-center justify-center text-accent-400">
                    <i className="ri-arrow-right-line text-lg"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}